import React from "react";
import Input from "../components/Utilities/Input";
import Button from "../components/Utilities/Button";
import ArrowLeft from "../../assets/svgs/ArrowLeft";
import { Link } from "react-router-dom";

const ResetPasswordRequest = () => {
  return (
    <div
      style={{
        background:
          "linear-gradient(224.99deg, #FA4A6F 7.89%, #BA004F 86.92%), #E252BF",
      }}
      className="pt-5 pb-10 flex flex-col justify-around items-center text-white hue-rotate-15 w-full min-h-screen"
    >
      <div className="fixed top-10 left-10">
        <Link to="/login">
          <button className="text-white hover:text-blue-300">
            <ArrowLeft />
          </button>
        </Link>
      </div>
      <div />
      <div className="px-5 sm:px-0 w-full sm:w-64 md:w-72 lg:w-80 flex flex-col justify-center items-center space-y-5">
        <div className="w-16 h-16 rounded-lg bg-gray-200"></div>
        <h3 className="text-lg">Agile</h3>
        <h3 className="text-lg">Reset Password</h3>
        <Input type="email" placeholder="Email" />
        <Link to="/reset-password">
          <Button text="Reset Password" />
        </Link>
      </div>

      <p className="p-6 border-t-2 uppercase text-base">
        <span className="text-gray-300">Already did this?</span>{" "}
        <Link to="/login" className="text-blue-300">
          LOGIN
        </Link>
      </p>
    </div>
  );
};

export default ResetPasswordRequest;
